import Configuration from "./configuration";
import moment from "moment";

class IndicatorService {
  constructor(token) {
    this.config = new Configuration(token, null, "api/Indicator");
  }

  /**
   * @method getCompanyControlPanel list campaigns dashboard info
   * @return {Promise} result object
   */
  getCompanyControlPanel() {
    return this.config.API.get(`GetCompanyControlPanel`).then(response => {
      if (response.status !== 200) {
        return this.config.handleResponseError(response);
      }
      return response.data;
    });
  }

  /**
   * @method getDashboardCampaign get details campaings
   * @return {Promise} result object
   */
  getDashboardCampaign(campaignId) {
    const dateSearch = moment().format("Y-MM-DD HH:mm:ss");

    return this.config.API.get(`GetDashboardCampaign`, {
      params: {
        campaignId,
        dateSearch
      }
    }).then(response => {
      if (response.status !== 200) {
        return this.config.handleResponseError(response);
      }
      return response.data;
    });
  }
}

export default IndicatorService;
